/* -------------------------------------------------------------------------- */
/* Statuts et actions                                                          */
/* -------------------------------------------------------------------------- */
export const ORDER_STATUSES = [
    'PENDING',
    'IN_PREPARATION',
    'ON_HOLD',
    'READY',
    'SERVED',
    'COMPLETED',
    'CANCELLED',
];
export const ORDER_ACTIONS = [
    'START',
    'HOLD',
    'RESUME',
    'READY',
    'SERVE',
    'COMPLETE',
    'CANCEL',
];
/** Statuts terminaux. Aucune transition n'en sort. */
export const TERMINAL_ORDER_STATUSES = ['COMPLETED', 'CANCELLED'];
/** Statuts consideres comme actifs dans le kanban et le filtre `status=active`. */
export const ACTIVE_ORDER_STATUSES = [
    'PENDING',
    'IN_PREPARATION',
    'ON_HOLD',
    'READY',
    'SERVED',
];
/**
 * Table des transitions autorisees.
 * Source de verite : docs/06-cycle-de-vie-commande.md, section 3.
 * Toute combinaison absente est interdite.
 */
export const ORDER_TRANSITIONS = {
    PENDING: { START: 'IN_PREPARATION', HOLD: 'ON_HOLD', CANCEL: 'CANCELLED' },
    IN_PREPARATION: { READY: 'READY', HOLD: 'ON_HOLD', CANCEL: 'CANCELLED' },
    ON_HOLD: { RESUME: 'IN_PREPARATION', CANCEL: 'CANCELLED' },
    READY: { SERVE: 'SERVED', HOLD: 'ON_HOLD', CANCEL: 'CANCELLED' },
    SERVED: { COMPLETE: 'COMPLETED', CANCEL: 'CANCELLED' },
    COMPLETED: {},
    CANCELLED: {},
};
export function isTerminalStatus(status) {
    return TERMINAL_ORDER_STATUSES.includes(status);
}
export function nextStatus(from, action) {
    return ORDER_TRANSITIONS[from][action] ?? null;
}
/* -------------------------------------------------------------------------- */
/* Statut affiche au client                                                    */
/* -------------------------------------------------------------------------- */
export const CUSTOMER_ORDER_STATUSES = [
    'PENDING',
    'PREPARING',
    'READY',
    'SERVED',
    'CANCELLED',
];
/**
 * Traduction du statut interne vers le statut montre au client.
 * ON_HOLD est volontairement presente comme PREPARING : voir
 * docs/06-cycle-de-vie-commande.md, section 5.
 *
 * Le serveur applique cette fonction et transmet le resultat. Le frontend ne
 * la recalcule pas.
 */
export function toCustomerStatus(status) {
    switch (status) {
        case 'PENDING':
            return 'PENDING';
        case 'IN_PREPARATION':
        case 'ON_HOLD':
            return 'PREPARING';
        case 'READY':
            return 'READY';
        case 'SERVED':
        case 'COMPLETED':
            return 'SERVED';
        case 'CANCELLED':
            return 'CANCELLED';
    }
}
/* -------------------------------------------------------------------------- */
/* Colonnes du kanban admin                                                    */
/* -------------------------------------------------------------------------- */
export const BOARD_COLUMNS = ['NEW', 'IN_PROGRESS', 'READY', 'SERVED', 'COMPLETED'];
/**
 * Regroupement des statuts par colonne. Voir docs/06, section 4.
 *
 * `ON_HOLD` n'a plus de colonne : une commande en attente reste « en cours »
 * pour le personnel, signalee par une pastille. `CANCELLED` vaut `null` : une
 * commande annulee quitte le tableau et se consulte dans l'historique.
 * Voir docs/adr/0011-cycle-de-vie-a-cinq-etats.md.
 */
export const COLUMN_BY_STATUS = {
    PENDING: 'NEW',
    IN_PREPARATION: 'IN_PROGRESS',
    ON_HOLD: 'IN_PROGRESS',
    READY: 'READY',
    SERVED: 'SERVED',
    COMPLETED: 'COMPLETED',
    CANCELLED: null,
};
export const EVENT_ACTORS = ['CUSTOMER', 'STAFF', 'SYSTEM'];
//# sourceMappingURL=order.js.map